import { styled, Dialog } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const getWidth = (size, width, type) => size != null && size !== "auto" ? `${sizesMap[size]}px` : size === "auto" ? type === "max-width" ? "initial" : "auto" : `${sizesMap.sm}px`, sizesMap = {
  xs: 400,
  sm: 480,
  md: 560,
  lg: 640,
  xl: 720,
  xxl: 800
}, StyledDialog = styled(
  Dialog,
  shouldNotForwardProps([
    "size",
    "fullHeight",
    "noContentPaddings",
    "fullFrameMobile"
  ])
)(
  ({ theme: t, size, fullHeight, fullFrameMobile, noContentPaddings }) => ({
    borderRadius: 0,
    ".MuiPaper-root": {
      borderRadius: 0,
      color: "inherit",
      width: getWidth(size),
      margin: 0,
      maxWidth: ["lg", "xl", "xxl"].includes(size ?? "") || size === "auto" ? "initial" : "",
      minHeight: fullHeight ? "90%" : "",
      "&.MuiDialog-paperWidthSm": {
        [t.breakpoints.down("sm")]: {
          width: "calc(100% - 32px)",
          marginRight: 0,
          marginLeft: 0
        }
      },
      [t.breakpoints.down("sm")]: {
        minWidth: fullFrameMobile ? "100%" : "initial !important",
        minHeight: fullFrameMobile ? "100%" : void 0
      },
      "&.MuiDialog-paperFullWidth": {
        width: "96%"
      }
    },
    ".MuiDialogContent-root": {
      textAlign: size === "sm" ? "center" : "left",
      paddingLeft: noContentPaddings && 0,
      paddingRight: noContentPaddings && 0
    },
    ".MuiDialogActions-root": {
      justifyContent: size === "md" ? "space-between !important;" : size === "sm" ? "center" : "initial"
    }
  })
);
StyledDialog.defaultProps = {
  keepMounted: !1,
  size: "xs",
  disableScrollLock: !0
};
export {
  StyledDialog
};
//# sourceMappingURL=StyledDialog.js.map
